const REPLAY_ATTEMPTS = 3;
const REPLAY_BACKOFF_MS = 200;

const backoff = () =>
  new Promise<void>((resolve) => {
    const timer = setTimeout(resolve, REPLAY_BACKOFF_MS) as unknown as { unref?: () => void };
    timer.unref?.();
  });

/**
 * Replays a request that 401'd, tolerating the gap between another tab winning the
 * token refresh and its rotated cookie reaching this tab's jar.
 *
 * Used when `/token/refresh` answers `200 { refreshed: false }`: the session is alive
 * but this tab was not issued a token, so an immediate replay can still be unauthorized.
 */
export const replayWhileUnauthorized = async <T>(
  replay: () => Promise<T>,
  isUnauthorized: (result: T) => boolean
): Promise<T> => {
  let result = await replay();
  for (let attempt = 1; attempt < REPLAY_ATTEMPTS && isUnauthorized(result); attempt += 1) {
    await backoff();
    result = await replay();
  }
  return result;
};
